var map = {
	"./chatBarController.js": 47,
	"./chatController.js": 48,
	"./detailsController.js": 49,
	"./dialogController.js": 50,
	"./dialogHeaderController.js": 51,
	"./dialogMessagesController.js": 52,
	"./dialogsController.js": 53,
	"./friendsController.js": 54,
	"./linkCardController.js": 55,
	"./linkCardMessagesController.js": 56,
	"./playTogetherController.js": 57,
	"./userConversationInfoController.js": 58,
	"./voiceController.js": 59
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 46;